import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import 'nprogress/nprogress.css';
import 'pure-react-carousel/dist/react-carousel.es.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-quill/dist/quill.snow.css';
import 'simplebar-react/dist/simplebar.min.css';
import './__fakeData__';
import App from './App';
import { SettingsProvider } from './contexts/settingsContext';
import './styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <SettingsProvider>
        <App />
      </SettingsProvider>
    </LocalizationProvider>
  </React.StrictMode>
);
